import { motion } from "framer-motion";

const contentBlocks = [
  {
    title: "Digital Architecture",
    image: "https://placehold.co/1200x800?text=BCS+Digital+Architecture",
    imageAlt: "BCS ICT operations",
    overlayImage: "https://placehold.co/560x360?text=ICT+Infrastructure",
    overlayAlt: "ICT infrastructure placeholder",
    paragraphs: [
      "The BCS Information and Communication Technology Bureau provides architectural technology solutions for the Brotherhood of the Cross and Star, including programming, website updates, database management, and technical support.",
      "The team builds and maintains systems that support mission operations across departments and locations.",
    ],
  },
  {
    title: "Platform Development and Data Management",
    image: "https://placehold.co/1200x800?text=BCS+Digital+Platforms",
    imageAlt: "Digital platforms placeholder",
    overlayImage: "https://placehold.co/560x360?text=Data+Management",
    overlayAlt: "Data management placeholder",
    paragraphs: [
      "The Bureau creates programs tailored to organizational needs and manages the official website and digital channels.",
      "The Bureau also supports secure and efficient access to organizational data, enabling multiple applications and users to work with shared information from a single repository.",
    ],
  },
  {
    title: "Technical Support",
    image: "https://placehold.co/1200x800?text=ICT+Support+Services",
    imageAlt: "ICT support services placeholder",
    overlayImage: "https://placehold.co/560x360?text=Training+and+Helpdesk",
    overlayAlt: "ICT training and helpdesk placeholder",
    paragraphs: [
      "BCS ICT Bureau provides direct support to computer users across the organization, including software installation, hardware maintenance, troubleshooting, and system setup.",
      "The Bureau also trains users on new tools so teams can work effectively and consistently across BCS operations.",
    ],
  },
];

const ICT = () => {
  return (
    <motion.main
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 1.1,
        delay: 0.2,
        ease: [0, 0.71, 0.2, 1.01],
      }}
      className="relative z-0 w-full bg-white text-slate-900"
    >
      <header className="relative z-0 pt-24 mt-24 md:pt-32 px-6 md:px-20 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[20px] h-[20px] rounded-full bg-blue-200/40 blur-[10px]" />
          <div className="absolute bottom-0 left-1/4 w-[10px] h-[10px] rounded-full bg-blue-100/50 blur-[10px]" />
          <div className="absolute bottom-0 right-1/4 w-[10px] h-[10px] rounded-full bg-indigo-100/50 blur-[10px]" />
        </div>

        <div className="relative max-w-5xl mx-auto flex flex-col items-center text-center gap-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="inline-flex items-center gap-4"
          ></motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="space-y-4"
          >
            <h1 className="text-5xl md:text-7xl font-black text-stone-900 tracking-tighter leading-none uppercase">
              BCS ICT <span className="text-blue-600 italic">Bureau.</span>
            </h1>
            <p className="text-stone-500 text-base md:text-xl font-medium leading-relaxed max-w-3xl mx-auto">
              Engineering digital systems, platforms, and user support services
              that strengthen operations across the Kingdom.
            </p>
          </motion.div>
        </div>
      </header>

      <section className="px-6 md:px-20 py-16 md:py-28 space-y-28">
        {contentBlocks.map((block, index) => {
          const isOdd = index % 2 !== 0;
          const overlayAlignmentClass = isOdd ? "-left-10" : "-right-10";

          return (
            <article
              key={block.title}
              className="grid md:grid-cols-2 gap-14 md:gap-24 items-center"
            >
              <div className={isOdd ? "md:order-2" : ""}>
                <div className="relative">
                  <img
                    src={block.image}
                    alt={block.imageAlt}
                    className="w-full h-[300px] md:h-[420px] object-cover border border-slate-300"
                  />
                  <img
                    src={block.overlayImage}
                    alt={block.overlayAlt}
                    className={`hidden md:block absolute -bottom-10 ${overlayAlignmentClass} w-[46%] h-[180px] object-cover border-4 border-white shadow-xl`}
                  />
                </div>
              </div>

              <div className={`${isOdd ? "md:order-1" : ""} md:px-6 lg:px-10`}>
                <h2 className="text-2xl md:text-4xl leading-tight font-semibold text-slate-900">
                  {block.title}
                </h2>
                <div className="mt-6 space-y-4 text-base md:text-lg leading-relaxed text-slate-700">
                  {block.paragraphs.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                </div>
              </div>
            </article>
          );
        })}
      </section>
    </motion.main>
  );
};

export default ICT;
